export default __webpack_public_path__ + "static/neue-haas-grotesk-display-55-roman-17a1b620534b502ceb054cacdc7eb285.woff";